import React from 'react'
import 'aframe';
import 'aframe-particle-system-component';
import 'aframe-mouse-cursor-component'
import 'aframe-touch-look-controls'
import {Entity, Scene, Cursor, Camera} from 'aframe-react'

class Viewer360 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            zoom: 80,
            zoomValue: 0,
            isTouchScreen: false
        }
    }

    componentDidUpdate(prevProps){
        if(prevProps.currentImage !== this.props.currentImage){
            this.props.on360ready()
        }
    }

    handleZoom = (event) => {

        var rotation = document.querySelector('a-scene').camera.el.object3D;

        var value = event.deltaY < 0 ? -1.5 : 1.5
        this.setState({
            zoomValue: this.state.zoomValue + value
        }, () => {
            this.state.zoomValue < -30 ? this.setState({
                zoomValue: -30
            }):
            this.state.zoomValue > 10 ? this.setState({
                zoomValue: 10
            }):
            this.setState({
                zoom: this.state.zoom + value
            })
        })
    }

    handleTouchScreen = (event) => {
        this.setState({
            isTouchScreen: true
        })
    }

    handleMouse = () => {
        this.setState({
            isTouchScreen: false
        })
    }

    render(){
        return(
            <div className={this.props.isViewer360 ? 'viewer-360 fade-in':'viewer-360 fade-out'} onWheel={(e) => {this.handleZoom(e)}} onTouchStart={(e) => {this.handleTouchScreen(e)}}>
                {
                    <Scene cursor="rayOrigin: mouse; fuse: false" raycaster="objects: .raycastable">
                        <Entity ref={this.camera}>
                        {
                            !this.state.isTouchScreen ?
                            <a-camera id="camera" fov={this.state.zoom} wasd-controls="adEnabled: false; enabled: false; wsEnabled: false"  look-controls="reverseMouseDrag: true; reverseTouchDrag: true" aframe-injected="" data-aframe-inspector-original-camera=""/>:
                            <a-camera  id="camera" fov={this.state.zoom}  wasd-controls="adEnabled: false; enabled: false; wsEnabled: false"  aframe-injected="" data-aframe-inspector-original-camera="" camera="" touch-look-controls="reverseMouseDrag: true; reverseTouchDrag: true"></a-camera>
                        }
                        </Entity>
                        <Entity primitive='a-sky' src={this.props.currentImage} segments-height={100} segments-width={200} radius={200} />
                    </Scene>
                }
            </div>
        )
    }
}

export default Viewer360